import React, { useMemo, useRef, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { registerEChartsTheme } from "../../Utilities/echartsTheme";

registerEChartsTheme();

const EChart = ({ option, style, onEvents, notMerge = false, opts }) => {
  const chartRef = useRef(null);
  const mergedStyle = useMemo(
    () => ({ height: "100%", width: "100%", ...style }),
    [style]
  );

  useEffect(() => {
    const handleResize = () => {
      if (chartRef.current) {
        chartRef.current.getEchartsInstance().resize();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      style={mergedStyle}
      theme="techbazaar"
      notMerge={notMerge}
      onEvents={onEvents}
      opts={opts}
    />
  );
};

export default EChart;
